<script setup lang="ts">
import TableFooterBar from '@/components/bars/TableFooterBar.vue';
import KBtn from '@/components/btns/KBtn.vue';
import TablePageFooter from '@/components/footers/TablePageFooter.vue';
import ExportAsCsvIconBtn from '@/components/iconBtns/ExportAsCsvIconBtn.vue';
import ExportAsPdfIconBtn from '@/components/iconBtns/ExportAsPdfIconBtn.vue';
import EtaReportSearchForm from '@/components/searchForms/EtaReportSearchForm.vue';
import EtaReportTable from '@/components/tables/EtaReportTable.vue';
import FormWrapper from '@/components/wrappers/FormWrapper.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useCommonRouteQuery from '@/composables/routeQueries/useCommonRouteQuery';
import useCurrentDateString from '@/composables/useCurrentDateString';
import useEtaReportView from '@/composables/views/useEtaReportView';
import { defCurPage, defPageSize } from '@/constants/routeQuery';

const { getCurrentQueryDate } = useCurrentDateString();
const { queryCurPage, queryPageSize, queryCustomer, queryDate } =
  useCommonRouteQuery({
    queryCurPage: defCurPage,
    queryPageSize: defPageSize,
    queryDate: getCurrentQueryDate(),
  });

const {
  search,
  initialData,
  isFetchingData,
  isSendingReport,
  isDownloadingPDF,
  isDownloadingCSV,
  etaReportData,
  handleSendClick,
  downloadPdfETAReport,
  downloadCsvETAReport,
} = useEtaReportView(queryCurPage, queryPageSize, queryCustomer, queryDate);
</script>

<template>
  <div :class="$style.etaReportView" data-testid="etaReportView">
    <PageContentWrapper>
      <FormWrapper :class="$style.formWrapper">
        <EtaReportSearchForm
          :initial-data="initialData"
          :loading="isFetchingData"
          :class="$style.form"
          @submit="search"
        />
      </FormWrapper>
      <TablePageShadowWrapper
        v-if="queryDate"
        :class="$style.tablePageShadowWrapper"
      >
        <EtaReportTable
          :loading="isFetchingData"
          :data="etaReportData.results || []"
          :date="queryDate"
        />
        <TablePageFooter
          v-if="etaReportData.results?.length"
          :cur-page="queryCurPage"
          :page-size="queryPageSize"
          :total="etaReportData.count"
        >
          <ExportAsPdfIconBtn
            class="mr-2"
            :disabled="isFetchingData || !etaReportData.results?.length"
            :loading="isDownloadingPDF"
            @click="downloadPdfETAReport()"
          />
          <ExportAsCsvIconBtn
            :disabled="isFetchingData || !etaReportData.results?.length"
            :loading="isDownloadingCSV"
            @click="downloadCsvETAReport()"
          />
        </TablePageFooter>
      </TablePageShadowWrapper>
    </PageContentWrapper>
    <TableFooterBar>
      <KBtn
        size="lg"
        append-icon="mdi-send"
        :disabled="isFetchingData || !etaReportData.results?.length"
        :loading="isSendingReport"
        @click="handleSendClick"
      >
        Send ETA Report
      </KBtn>
    </TableFooterBar>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.etaReportView {
}
  .formWrapper {
    padding: 2.4rem 1.5rem 0.5rem 1.5rem;
    max-width: variables.$tableWrapperWidth;
    margin: 2rem 0;
  }
  .tablePageShadowWrapper {
    max-width: variables.$tableWrapperWidth;
  }
</style>
